
import RpIcon from "@/components/RpIcon";
import { isDark } from "@/utils/utils";
import { alpha, Box, Stack, styled, useTheme } from "@mui/material";
import "swiper/css";

const StyledStack = styled(Stack)(({ theme }) => ({
  '.icon-title': {
    '.icon': {
      height: '16px',
      width: '16px',
    },
    '.title': {
      fontSize: '13px',
      fontWeight: 400,
      color: theme.palette.text.secondary
    }
  },
  '.amount-title': {
    '.amount': {
      fontSize: '32px',
      fontWeight: 700,
      color: theme.palette.text.primary,
      paddingInlineEnd: '4px',
    },
    '.currency': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '32px',
    }
  },
  '.status-tag': {
    padding: '4px 12px',
    borderRadius: '32px',
    // display: 'inline-block',
    backgroundColor: theme.palette.background.card,
    '.iconfont': {
      marginInlineEnd: '4px',
    },
    '.title': {
      fontSize: '13px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
    '&.success': {
      color: theme.palette.success.main,
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      '.title': {
        color: theme.palette.success.main,
      }
    },
    '&.error': {
      color: theme.palette.error.main,
      // backgroundColor: alpha(theme.palette.error.main, 0.1),
      '.title': {
        color: theme.palette.error.main,
      }
    },
    '&.warning': {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.1),
      '.title': {
        color: theme.palette.warning.main,
      }
    }
  },
  '.status-tag-declined': {
    padding: '4px 12px',
    borderRadius: '32px',
    // display: 'inline-block',
    // backgroundColor: theme.palette.background.card,
    '.iconfont': {
      marginInlineEnd: '4px',
    },
    '.title': {
      fontSize: '13px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
    '&.success': {
      color: theme.palette.success.main,
      // backgroundColor: alpha(theme.palette.success.main, 0.1),
      '.title': {
        color: theme.palette.success.main,
      }
    },
    '&.error': {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.1),
      '.title': {
        color: theme.palette.error.main,
      }
    },
    '&.warning': {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.1),
      '.title': {
        color: theme.palette.warning.main,
      }
    }
  },
  '.status-tag-visa-transaction': {
    padding: '4px 12px',
    borderRadius: '32px',
    // display: 'inline-block',
    backgroundColor: theme.palette.background.card,
    '.iconfont': {
      marginInlineEnd: '4px',
    },
    '.title': {
      fontSize: '13px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
    '&.success': {
      color: theme.palette.success.main,
      // backgroundColor: alpha(theme.palette.success.main, 0.1),
      '.title': {
        color: theme.palette.success.main,
      }
    },
    '&.error': {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.1),
      '.title': {
        color: theme.palette.error.main,
      }
    },
    '&.warning': {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.1),
      '.title': {
        color: theme.palette.warning.main,
      }
    }
  },
  '.side-img': {
    width: '72px',
    height: '72px',
  }
}));

const RecordHeader = (
  { icon, iconFilter = false, iconWidget, iconTitle, statusColor, statusIcon,
    statusDisplay, amount, currencyCode,
    isDeclined, isVisaTransfer, isRefund
  }
) => {
  const theme = useTheme();
  const dark = isDark(theme);

  return <StyledStack direction={'row'} width={'100%'} alignItems={'center'} justifyContent={'space-between'}>
    <Stack direction={'column'}>
      <Stack direction={'row'} alignItems={'center'} className="icon-title" spacing={'4px'}>
        {!!iconWidget ? iconWidget : <img className="icon" src={icon} style={{ filter: `${iconFilter ? 'grayscale(100%)' : 'none'}` }} />}
        <span className="title">{iconTitle}</span>
      </Stack>

      <Stack direction={'row'} className="amount-title" alignItems="flex-end">
        <div className="amount">{amount}</div>
        <div className="currency">{currencyCode}</div>
      </Stack>
      {
        isVisaTransfer && <Stack direction="row" alignItems="center">
          <Stack direction="row" alignItems="center" className={`status-tag-visa-transaction ${statusColor ?? ''}`}
                 gap="4px">
            {statusIcon && <RpIcon icon={statusIcon} size={16}/>}
            <span className="title" style={{fontSize: '14px'}}>{statusDisplay}</span>
          </Stack>
        </Stack>
      }
      {!isVisaTransfer && isDeclined && <Stack direction="row" alignItems="center">
        <Stack direction="row" alignItems="center" className={`status-tag-declined ${statusColor ?? ''}`} gap="2px">
          {/*<img className="icon" src={icon}*/}
          {/*     style={{filter: `${iconFilter ? 'grayscale(100%)' : 'none'}`, width: '16px', height: '16px'}}/>*/}
          {/*{!!iconWidget ? iconWidget : <img className="icon" src={icon} style={{ filter: `${iconFilter ? 'grayscale(100%)' : 'none'}` }} />}*/}
          <RpIcon color={theme.palette.brand.main} size={14} icon="close-circle" />
          <span className="title" style={{color: theme.palette.brand.main, fontSize: '14px'}}>{statusDisplay}</span>
        </Stack>
      </Stack>}
      {!isVisaTransfer && !isDeclined && !isRefund && statusDisplay && <Stack direction="row" alignItems="center">
        <Stack direction="row" alignItems="center" className={`status-tag ${statusColor ?? ''}`}>
          {statusIcon && <RpIcon icon={statusIcon} size={16}/>}
          {/*{!!iconWidget ? iconWidget : <img className="icon" src={icon} style={{ filter: `${iconFilter ? 'grayscale(100%)' : 'none'}` }} />}*/}
          <span className="title">{statusDisplay}</span>
        </Stack>
      </Stack>}
      {!isVisaTransfer && isRefund && statusDisplay && <Stack direction="row" alignItems="center">
        <Stack direction="row" alignItems="center" className={`status-tag ${statusColor ?? ''}`}>
          {statusIcon && <RpIcon icon={statusIcon} size={16}/>}
          {/*{!!iconWidget ? iconWidget : <img className="icon" src={icon} style={{ filter: `${iconFilter ? 'grayscale(100%)' : 'none'}` }} />}*/}
          <span className="title">{statusDisplay}</span>
        </Stack>
      </Stack>}
    </Stack>
    <img className="side-img" src={`/images/record-log${dark ? '-dark' : ''}.svg`}/>
  </StyledStack>
};

export default RecordHeader;
